import { render } from "./ElitePrograms.vue?vue&type=template&id=64a65220&scoped=true"
import script from "./ElitePrograms.vue?vue&type=script&lang=js"
export * from "./ElitePrograms.vue?vue&type=script&lang=js"

import "./ElitePrograms.vue?vue&type=style&index=0&id=64a65220&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a65220"]])

export default __exports__